import styled from '@emotion/styled';
import { Flex } from '@qga/roo-ui/components';
import { ItemLink, ItemLinkProps } from './ItemLink';

const StyledFlex = styled(Flex)`
  min-width: 166px;
`;

interface ItemLinksProps {
  links?: ItemLinkProps[];
  [key: string]: any;
}

export const ItemLinks = ({ links = [], ...props }: ItemLinksProps) => (
  <StyledFlex
    flexDirection="column"
    width={['100%', '38%']}
    borderLeft={[0, 1]}
    borderColor={['none', 'greys.alto']}
    px={4}
    pt={[0, 6]}
    pb={[4]}
    {...props}
  >
    {links.map((linkProps, index) => (
      <ItemLink {...linkProps} key={`item-link-${index}`} />
    ))}
  </StyledFlex>
);
